import React from 'react'
import { Box, Container } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { Breakpoint } from '@mui/system'

import NavNextLink from '@/components/EMT/NavNextLink'
import { Routes } from '@/assets/configs'
import { useIsQueryOwner } from '@/hooks'
import useRouter from 'next/router'

import {
  // EmtChip,
  EmtIcon,
  EmtTypography,
} from 'emt-components-v2'

enum ActiveItem {
  Search = 'search',
  Messages = 'messages',
  Favorites = 'favorites',
}

interface Props {
  containerMaxWidth?: Breakpoint | false
  sx?: React.CSSProperties
}

const BorrowersNav: React.FC<Props> = ({ containerMaxWidth = 'lg', sx }) => {
  const { t } = useTranslation('common')
  const [, , appendQueryType] = useIsQueryOwner()
  const router = useRouter

  // TODO:
  // const badge = 3

  let activeItem: ActiveItem | null = null
  switch (router.pathname) {
    case Routes.Search._pathname:
      activeItem = ActiveItem.Search
      break
    case Routes.Message._pathname:
      activeItem = ActiveItem.Messages
      break
    case Routes.Favorites._pathname:
      activeItem = ActiveItem.Favorites
      break
    default:
      break
  }

  return (
    <Box
      sx={{
        ...sx,
        height: '68px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'primary.main',
        position: 'relative',
      }}
    >
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          height: '100%',
        }}
        maxWidth={containerMaxWidth}
      >
        <EmtTypography variant="h6" fontWeight="bold" color="white" alignSelf="center">
          {t('borrowers')}
        </EmtTypography>
        <Box
          sx={{
            display: 'flex',
            gap: '30px',
          }}
        >
          <NavNextLink
            sx={{
              borderTop: '6px solid transparent',
              borderBottom: activeItem === ActiveItem.Search ? '6px solid #fff' : '6px solid transparent',
              '& p, .emt-icons, p>span': {
                color: activeItem === ActiveItem.Search ? '#fff!important' : '#fff!important',
              },
              '&:hover': {
                '& p, .emt-icons, p>span': {
                  color: '#fff!important',
                },
              },
            }}
            href={appendQueryType(Routes.Search._pathname)}
          >
            <EmtIcon
              className="emt-search-1"
              sx={{
                fontSize: '16px',
              }}
            />
            <EmtTypography variant="body2" fontWeight="bold">
              {t('navigation.search.dogowner')}
            </EmtTypography>
          </NavNextLink>
          <NavNextLink
            sx={{
              borderTop: '6px solid transparent',
              borderBottom: activeItem === ActiveItem.Messages ? '6px solid #fff' : '6px solid transparent',
              '& p, .emt-icons, p>span': {
                color: activeItem === ActiveItem.Messages ? '#fff!important' : '#fff!important',
              },
              '&:hover': {
                '& p, .emt-icons, p>span': {
                  color: '#fff!important',
                },
              },
            }}
            href={appendQueryType(Routes.Message._pathname)}
          >
            <EmtIcon
              className="emt-message-1"
              sx={{
                fontSize: '16px',
              }}
            />
            <EmtTypography variant="body2" fontWeight="bold">
              {t('navigation.messages')}
            </EmtTypography>
          </NavNextLink>
          <NavNextLink
            sx={{
              borderTop: '6px solid transparent',
              borderBottom: activeItem === ActiveItem.Favorites ? '6px solid #fff' : '6px solid transparent',
              '& p, .emt-icons, p>span': {
                color: activeItem === ActiveItem.Favorites ? '#fff!important' : '#fff!important',
              },
              '&:hover': {
                '& p, .emt-icons, p>span': {
                  color: '#fff!important',
                },
                '& .MuiChip-label': {
                  color: 'primary.main!important',
                },
              },
            }}
            href={appendQueryType(Routes.Favorites._pathname)}
          >
            <EmtIcon
              className="emt-heart-1"
              sx={{
                fontSize: '16px',
              }}
            />
            <EmtTypography variant="body2" fontWeight="bold">
              {t('navigation.favorites')}
            </EmtTypography>
            {/* {!!badge && (
              <EmtChip
                color="white"
                type="roundedNumber"
                label={badge}
                sx={{ backgroundColor: '#fff', '& span': { color: 'primary.main!important', paddingTop: '1px' } }}
              />
            )} */}
          </NavNextLink>
        </Box>
      </Container>
    </Box>
  )
}

export default BorrowersNav
